import React, { useCallback } from 'react';
import { SimpleTab } from 'components/components/SimpleTab';
import HorizontalScroll from 'components/Elements/HorizontalScroll/HorizontalScroll';
import { useIsMobileDevice } from 'utils';
import * as Styled from './CategoryFilter.styles';
import {
  clearAnalyticsEvents,
  sendCategoryChangeAnalyticsEvent,
} from '../../helpers/analitycs';
import { categoryFacetType } from '../../types';

interface CategoryFilterProps {
  filterCategories: categoryFacetType;
  selectedCategoryId: string | null;
  onCategoryChange: (categoryId: string | null) => void;
}

export const CategoryFilter: React.FC<CategoryFilterProps> = (props) => {
  const { selectedCategoryId, onCategoryChange, filterCategories } = props;
  const isMobile = useIsMobileDevice('md');

  const handleCategoryChange = useCallback(
    (categoryId: string, name: string, results: number) => {
      clearAnalyticsEvents({
        filter: null,
      }).then(() => {
        sendCategoryChangeAnalyticsEvent({
          selectedCategoryId: categoryId,
          name,
          results,
        });
      });
      onCategoryChange(categoryId);
    },
    [selectedCategoryId, onCategoryChange],
  );

  return (
    <Styled.Container>
      <HorizontalScroll
        isDraggable={false}
        arrowScrollingPercent={0.8}
        showArrows={!isMobile}
      >
        <Styled.Wrapper>
          {filterCategories.values.map(
            (value) =>
              value.count > 0 && (
                <SimpleTab
                  key={value.category_id}
                  title={value.label}
                  selected={selectedCategoryId === value.category_id}
                  onTabClick={() =>
                    handleCategoryChange(
                      value.category_id ? value.category_id : value.label,
                      value.label,
                      value.count,
                    )
                  }
                  counter={value.count}
                />
              ),
          )}
        </Styled.Wrapper>
      </HorizontalScroll>
    </Styled.Container>
  );
};
